import { render, staticRenderFns } from "./HelloWorldPage.vue?vue&type=template&id=7b8019a8&"
import script from "./HelloWorldPage.vue?vue&type=script&lang=js&"
export * from "./HelloWorldPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports